<template>
  <div>
    <ministry-breadcrumbs :mainTitle="pageTitle" :breadcrumbs="breadcrumbs" />
    <b-card>
      <div class="ml-auto" style="width: fit-content">
        <b-button @click="openFilterForm" type="submit" variant="success">
          <feather-icon class="mr-25" icon="FilterIcon" />
          فلترة</b-button
        >
        <b-button
          class="mx-50"
          @click="clearFilters"
          :disabled="!searchForm"
          type="submit"
          variant="flat-danger"
        >
          <feather-icon class="mx-25" icon="XIcon" />
          الغاء الفلاتر</b-button
        >
        <b-button @click="exportTable" variant="outline-info">
          <feather-icon class="mr-25" icon="DownloadIcon" />
          تصدير الجدول</b-button
        >
      </div>

      <form-modal
        v-model="showFilterSidebar"
        :formSchema="filterFormSchema"
        forceSide
        @confirm="onSearch"
        ref="filterForm"
        confirmLabel="فلترة"
        confirmIcon="FilterIcon"
      />

      <b-form-row class="mb-1 align-items-center justify-content-end w-100">
        <b-col class="justify-content-end d-flex" cols="3"> </b-col>
      </b-form-row>

      <router-data-table
        :search.sync="getSearch"
        :currentPage.sync="getPageNum"
        :perPage.sync="getPageSize"
        :sort-by.sync="sortBy"
        :sort-desc.sync="getSortDesc"
        ref="ngosDataTable"
        :ep="ep"
        :fields="fields"
        hover
        striped
      >
        <template #cell(details)="row">
          <b-button
            class="btn-icon rounded-circle"
            variant="flat-info"
            :title="!showDetails ? 'عرض التفاصيل' : 'إخفاء التفاصيل'"
            size="sm"
            v-b-tooltip.hover.v-info.bottom
            @click="onShowDetails(row)"
          >
            <feather-icon
              :icon="showDetails ? 'ChevronUpIcon' : 'ChevronDownIcon'"
            ></feather-icon>
          </b-button>
        </template>

        <template #row-details="row">
          <b-card class="shadow">
            <div style="position: relative">
              <loading-overlay :loading="loading" />
              <b-row class="mb-2">
                <template v-for="(val, key) in dataObj">
                  <b-col
                    :key="key"
                    v-if="val && key !== '_showDetails'"
                    md="4"
                    class="mb-1 d-flex"
                  >
                    <h5>{{ $t(key) }} :</h5>
                    <div class="text-info mx-1">{{ row.item[key] }}</div>
                  </b-col>
                </template>
              </b-row>

              <b-button
                size="sm"
                variant="outline-secondary"
                @click="
                  row.toggleDetails();
                  showDetails = !showDetails;
                "
              >
                إخفاء التفاصيل
              </b-button>
            </div>
          </b-card>
        </template>
      </router-data-table>
    </b-card>
  </div>
</template>

<script>
import RouterDataTable from "@/components/router-data-table/index.vue";
import viewsMeta from "./views-meta";
import {
  BButton,
  BRow,
  BCol,
  BBreadcrumb,
  BBreadcrumbItem,
  BCard,
  BCardTitle,
  BFormRow,
  BForm,
  VBTooltip,
} from "bootstrap-vue";
import FormInput from "@/components/form-input/index.vue";
import FormSelect from "@/components/form-select/index.vue";
import FormModal from "@/components/FormModal.vue";
import { mapGetters, mapActions } from "vuex";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import MinistryBreadcrumbs from "../../components/MinistryBreadcrumbs.vue";
import axios from "axios";
export default {
  components: {
    RouterDataTable,
    BButton,
    BRow,
    BCol,
    BBreadcrumb,
    BBreadcrumbItem,
    BCard,
    BCardTitle,
    BFormRow,
    BForm,
    FormInput,
    FormSelect,
    FormModal,
    LoadingOverlay,
    MinistryBreadcrumbs,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    page: String,
    size: String,
    sortBy: String,
    sortDesc: String,
    searchKey: String,
    searchField: String,
    view: String,
  },
  data() {
    return {
      showDetails: false,
      key: null,
      field: null,
      showFilterSidebar: false,
      filterFormSchema: {},
      searchForm: null,
    };
  },
  computed: {
    ...mapGetters("Ministry/NgosData", ["dataObj", "labels", "loading"]),
    getSearch() {
      return this.searchForm
        ? this.searchForm
        : this.$route.query.search
        ? JSON.parse(this.$route.query.search)
        : {};
    },
    fields() {
      return viewsMeta[this.view].fields || [];
    },
    ep() {
      return this.view === "employees"
        ? `v2/ministry/reports/${this.view}?is_volunteer=false`
        : this.view === "volunteers"
        ? `v2/ministry/reports/${this.view}?is_volunteer=true`
        : `v2/ministry/reports/${this.view}`;
    },
    breadcrumbs() {
      return viewsMeta[this.view].breadcrumbs || [];
    },
    getPageNum() {
      return parseInt(this.page);
    },
    getPageSize() {
      return parseInt(this.size);
    },
    getSortDesc() {
      return this.sortDesc === "true" || this.sortDesc === "1";
    },
    pageTitle() {
      return viewsMeta[this.view].title || null;
    },
    getSearchKey() {
      return this.searchKey;
    },
    getSearchField() {
      return this.searchField;
    },
  },
  methods: {
    ...mapActions("Exporter", ["exportToExcel", "customExport"]),
    ...mapActions("Ministry/NgosData", ["fetchRecordData"]),
    clearFilters() {
      this.searchForm = null;
      this.$router.push(`${this.$route.path}?page=1`);
      this.$nextTick(() => {
        this.$refs.ngosDataTable.refreshTable();
      });
    },
    openFilterForm() {
      if (this.searchForm) {
        this.$refs.filterForm.init(this.searchForm);
      }
      this.showFilterSidebar = true;
    },
    onRowClicked(item) {
      this.$router.push({
        name: "report-view",
        params: { slug: this.view, id: item.id },
      });
    },
    exportTable() {
      if (this.view === "ngos") {
        // var urlToExport = axios.getUri({
        //   url: this.ep,
        //   params: {
        //     search: this.searchForm,
        //   },
        // });
        this.customExport({
          ep: this.ep,
          params: {
            search: this.searchForm,
          },
          headers: { "To-Custom-Excel": "NgoClassificationsExport" },
        });
      } else {
        var urlToExport = axios.getUri({
          url: this.ep,
          params: {
            search: this.searchForm,
          },
        });
        this.exportToExcel(urlToExport);
      }
    },
    onShowDetails(row) {
      row.toggleDetails();
      this.showDetails = !this.showDetails;
      if (this.showDetails) {
        this.fetchRecordData({ slug: this.view, id: row.item.id });
      }
    },

    onSearch(form) {
      this.searchForm = { ...form };
      if (this.page === "1") {
        this.$router.replace({
          ...this.$router.currentRoute,
          query: {
            ...this.$route.query,
            page: "1",
            search: JSON.stringify(form),
          },
        });
        this.$refs.ngosDataTable.refreshTable();
      } else {
        this.$router.replace({
          ...this.$router.currentRoute,
          query: {
            ...this.$route.query,
            page: "1",
            search: JSON.stringify(form),
          },
        });
        this.$refs.ngosDataTable.refreshTable();
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    if (!to.query.page) {
      next({ ...to, query: { page: 1, ...to.query } });
    } else {
      next();
    }
  },
  created() {
    var form = {};
    viewsMeta[this.view].fields.forEach((el) => {
      form[el.key] = {
        component: el.filterType,
        key: el.key,
        numberModel: el.numberModel,
        attrs: {
          label: el.label,
          ...el.filterMeta,
        },
      };
    });
    this.filterFormSchema = form;
  },
  mounted() {
    this.field = this.searchField;
    this.key = this.searchKey;
    if (this.$route.query.search) {
      this.$refs.filterForm.init(JSON.parse(this.$route.query.search));
      this.searchForm = JSON.parse(this.$route.query.search);
    }
  },
};
</script>
